module.exports = __webpack_public_path__ + "img/magnum-super.42d2ef25.svg";